module.exports = __webpack_public_path__ + "assets/img/left.4babbf88.png";